import { render, staticRenderFns } from "./US.vue?vue&type=template&id=06e38147&"
import script from "./US.vue?vue&type=script&lang=js&"
export * from "./US.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e38147')) {
      api.createRecord('06e38147', component.options)
    } else {
      api.reload('06e38147', component.options)
    }
    module.hot.accept("./US.vue?vue&type=template&id=06e38147&", function () {
      api.rerender('06e38147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/US.vue"
export default component.exports